module.exports = __webpack_public_path__ + "06_medium_gold.f56e74f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/06_medium_gold.png
// module id = 5Ckb
// module chunks = 0